module.exports = __webpack_public_path__ + "img/10_22.c5bf6316.png";